import { render, staticRenderFns } from "./textEditor.vue?vue&type=template&id=1dc4e4de"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports